import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthMonitor } from '../auth.monitor';

import { SharedModule } from '../shared.module';
import { CollegeScorecardSearchComponent } from './college-scorecard-search.component';
import { CollegeScorecardFieldsOfStudyComponent } from './fieldsOfStudy/fields-of-study.component';
import {
	CollegeScorecardSchoolComponent,
	CollegeScorecardDescriptionComponent,
	CollegeScorecardTestScoreComponent,
	CollegeScorecardGraduationRetentionComponent,
	CollegeScorecardCostComponent,
	CollegeScorecardFinancialAidComponent,
	CollegeScorecardEarningAfterSchoolComponent,
	CollegeScorecardAtAGlanceComponent,
} from './college-scorecard-school.component';

const cscRoutes: Routes = [
	{ path: 'Search', component: CollegeScorecardSearchComponent, canActivate: [AuthMonitor], data: { authenticate: false, routeName: "College Scorecard Search" } },
	{ path: 'School/:schoolId', component: CollegeScorecardSchoolComponent, canActivate: [AuthMonitor], data: { authenticate: false, routeName: "college Scorecard School" } },
	{ path: '**', component: CollegeScorecardSearchComponent, canActivate: [AuthMonitor], data: { authenticate: false, routeName: "College Scorecard Search" } }
];

@NgModule({
	imports: [
		SharedModule,
		RouterModule.forChild(cscRoutes)
	],
	declarations: [
		CollegeScorecardSearchComponent,
		CollegeScorecardSchoolComponent,
		CollegeScorecardDescriptionComponent,
		CollegeScorecardTestScoreComponent,
		CollegeScorecardGraduationRetentionComponent,
		CollegeScorecardCostComponent,
		CollegeScorecardFinancialAidComponent,
		CollegeScorecardEarningAfterSchoolComponent,
		CollegeScorecardAtAGlanceComponent,
		CollegeScorecardFieldsOfStudyComponent
	],
	exports: [
		CollegeScorecardSearchComponent,
		CollegeScorecardSchoolComponent
	],
	schemas: [CUSTOM_ELEMENTS_SCHEMA] /*for picc-range */
})
export class CollegeScorecardModule { }
